// ui/src/lib/logger/transports/console.ts
import { ITransport, LogMessage } from "../types";

export class ConsoleTransport implements ITransport {
  private readonly consoleMethods: Record<string, (message?: any, ...optionalParams: any[]) => void> = {
    debug: console.debug.bind(console),
    info: console.info.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console)
  };

  log(entry: LogMessage): void {
    const { level, message, ...context } = entry;
    const logger = this.consoleMethods[level] || console.log.bind(console);

    const logMessage = `[${entry.timestamp}] [${level.toUpperCase()}] ${message}`;
    logger(logMessage, context); // Pass context as object for better console inspection
  }
}
